import { render } from "./UserJobsForm.vue?vue&type=template&id=63afe157"
import script from "./js/userJobsForm.js?vue&type=script&lang=js&external"
export * from "./js/userJobsForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__